import CryptoJS from "crypto-js";
import logging from "app/shared/utils/logging"; // or generate sample key Buffer.from('FoCKvdLslUuB4y3EZlKate7XGottHski1LmyqJHvUhs=', 'base64');

const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPT_URI_KEY ? process.env.REACT_APP_ENCRYPT_URI_KEY : 'default';
const HMAC_SECRET_KEY = process.env.HMAC_SECRET_KEY ? process.env.HMAC_SECRET_KEY : '538f5cdfdddca69f55b05b43841114ba2f537ec0b150ee2e3485d95a4f709bc6';
export const encryptURI = (text: string): string => {
    try {
        if (text) {
            const encryptedText = CryptoJS.AES.encrypt(text, ENCRYPTION_KEY).toString();
            const e64 = CryptoJS.enc.Base64.parse(encryptedText);
            const val = e64.toString(CryptoJS.enc.Hex);
            logging.debug("_URI_ENCRYPT_INFO", `${text} -> ${val} `);
            return val;
        }
    } catch (e) {
        logging.debug("_URI_ENCRYPT_FAILED", 'Encryption Failed', e);
    }
    return text;
};

export const decryptURI = (cipherText: string): string => {
    try {
        if (cipherText) {
            const reb64 = CryptoJS.enc.Hex.parse(cipherText);
            const bytes = reb64.toString(CryptoJS.enc.Base64);
            const decryptTemp = CryptoJS.AES.decrypt(bytes, ENCRYPTION_KEY);
            return decryptTemp.toString(CryptoJS.enc.Utf8);
        }
    } catch (e) {
        logging.debug("_URI_ENCRYPT_FAILED", 'URI Decryption failed', e);
    }
    return cipherText;
};
export const hashSHA1 = (text: string): string => CryptoJS.SHA1(text).toString();

export const hashCardNumber = (
    cardNumber: string,
): string => CryptoJS.HmacSHA256(cardNumber, HMAC_SECRET_KEY)
.toString(CryptoJS.enc.Hex).slice(0, 12);
